import React, { createContext, useContext } from 'react'

import { CaptchaGateScope } from '../types/CaptchaGateTypes'

/**
 * Holds the captcha gate scope resolved once by the provider. Default is
 * `null` so a consumer rendered outside the provider fails secure (the hook
 * maps `null` -> `unknown` -> captcha ON) instead of throwing at login.
 */
export const CaptchaGateScopeContext = createContext<CaptchaGateScope | null>(
   null
)

interface CaptchaGateScopeProviderProps {
   scope: CaptchaGateScope
   children: React.ReactNode
}

export const CaptchaGateScopeProvider = (
   props: CaptchaGateScopeProviderProps
): React.ReactElement => {
   const { scope, children } = props
   return (
      <CaptchaGateScopeContext.Provider value={scope}>
         {children}
      </CaptchaGateScopeContext.Provider>
   )
}

export const useCaptchaGateScope = (): CaptchaGateScope | null =>
   useContext(CaptchaGateScopeContext)
